import { Plus, Trash2, X } from "lucide-react";
import { packTotals, ron } from "@/lib/bf";

const Items = ({ label, list, products, onChange, testId }) => (
  <div className="bfa-items">
    <small>{label}</small>
    {list.map((it, i) => (
      <div key={i} className="bfa-item">
        <select value={it.id} onChange={(e) => onChange(list.map((x, j) => (j === i ? { ...x, id: e.target.value } : x)))} data-testid={`${testId}-select-${i}`}>
          {products.map((p) => <option key={p.id} value={p.id}>{p.name}</option>)}
        </select>
        <input inputMode="numeric" value={it.qty} onChange={(e) => onChange(list.map((x, j) => (j === i ? { ...x, qty: Math.max(1, Math.min(99, parseInt(e.target.value, 10) || 1)) } : x)))} data-testid={`${testId}-qty-${i}`} />
        <button type="button" onClick={() => onChange(list.filter((_, j) => j !== i))} aria-label="Scoate"><X size={14} /></button>
      </div>
    ))}
    {products.length > 0 && (
      <button type="button" className="bfa-link" onClick={() => onChange([...list, { id: products[0].id, qty: 1 }])} data-testid={`${testId}-add`}><Plus size={12} /> Adaugă</button>
    )}
  </div>
);

export default function BFPackageEditor({ brand, cfg, setCfg }) {
  const products = cfg.products.filter((p) => p.brand === brand);
  const byId = Object.fromEntries(cfg.products.map((p) => [p.id, p]));
  const list = cfg.packages.filter((k) => k.brand === brand);
  const put = (nk) => setCfg({ ...cfg, packages: cfg.packages.map((k) => (k.id === nk.id ? nk : k)) });
  const add = () => setCfg({ ...cfg, packages: [...cfg.packages, { id: `pk${brand}${Date.now().toString(36)}`, brand, name: "Pachet nou", discount: 30, items: products[0] ? [{ id: products[0].id, qty: 1 }] : [], gifts: [], active: true }] });
  return (
    <div className="bfa-packs" data-testid="bfa-packs">
      {list.map((k) => {
        const t = packTotals(k, byId);
        return (
          <div key={k.id} className={`bfa-pack ${k.active ? "" : "is-off"}`} data-testid={`bfa-pack-${k.id}`}>
            <div className="bfa-pack-top">
              <input className="bfa-name" value={k.name} onChange={(e) => put({ ...k, name: e.target.value })} data-testid={`bfa-pack-name-${k.id}`} />
              <label><small>Discount %</small><input inputMode="numeric" value={k.discount} onChange={(e) => put({ ...k, discount: Math.min(90, Math.max(0, parseInt(e.target.value, 10) || 0)) })} data-testid={`bfa-pack-discount-${k.id}`} /></label>
              <label className="bfa-active"><input type="checkbox" checked={k.active} onChange={(e) => put({ ...k, active: e.target.checked })} data-testid={`bfa-pack-active-${k.id}`} /> Activ</label>
              <button type="button" className="bfa-del" onClick={() => setCfg({ ...cfg, packages: cfg.packages.filter((x) => x.id !== k.id) })} aria-label="Șterge pachetul" data-testid={`bfa-pack-delete-${k.id}`}><Trash2 size={15} /></button>
            </div>
            <div className="bfa-pack-cols">
              <Items label="Produse în pachet" list={k.items} products={products} onChange={(items) => put({ ...k, items })} testId={`bfa-pack-items-${k.id}`} />
              <Items label="Cadou" list={k.gifts} products={products} onChange={(gifts) => put({ ...k, gifts })} testId={`bfa-pack-gifts-${k.id}`} />
            </div>
            <p className="st-hint">Preț pachet <b data-testid={`bfa-pack-price-${k.id}`}>{ron(t.price)}</b> · normal {ron(t.normal)} + cadou {ron(t.gifts)} · valoare client final {ron(t.retail)}</p>
          </div>
        );
      })}
      <button type="button" className="st-btn st-btn--ghost" onClick={add} data-testid="bfa-add-pack"><Plus size={14} /> Adaugă pachet</button>
    </div>
  );
}
